import { useEffect } from "react";
import "./Incubation.css";
import { Backtotop, Floatinmenu, Underline } from "../../widgets";
import { FaComputer } from "react-icons/fa6";
import { incubation_menu, incubationFaculty, incubation_img_corousal } from "../../constants/incubation";

import { RadialMenu, Table, Heroimagecarousal } from "../../components";

const Incubation_Faculty_Mentors = () => {
  useEffect(() => {
    document.title = 'ACCET-CSE Department';
  }, []);
  const columns = [
    { field: "sno", header: "sno" },
    { field: "faculty", header: "Faculty Name" },
    { field: "Department", header: "Department" },
  ];
  return (
    <div className="incubationdept">
      <Heroimagecarousal
        key={incubation_img_corousal.id}
        title={incubation_img_corousal.title}
        img_list={incubation_img_corousal.img_list}
      />
      <section className="incubationdark">
        <Underline heading="Faculty Mentors" />
        <div className="dept_float_menu">
          <Floatinmenu logo={FaComputer} head="Menu" links={incubation_menu} />
        </div>
        <RadialMenu menu_links={incubation_menu} />
        <div className='incubation_mentors_table'>
          <Table data={incubationFaculty} columns={columns} />
        </div>
      </section>

      <Backtotop />
    </div>
  );
};

export default Incubation_Faculty_Mentors;
